import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-CBEEVPRGKJ");
};

export const trackPageview = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = ({ category, action, label, value }) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
